import { Container } from "../atoms/Container";
import { Eyebrow } from "../atoms/Eyebrow";
import { PortraitPlaceholder } from "../atoms/PortraitPlaceholder";

type SiteAboutProps = {
  mobile?: boolean;
};

export function SiteAbout({ mobile = false }: SiteAboutProps) {
  const pad = mobile ? 24 : 96;
  return (
    <section
      style={{
        paddingTop: mobile ? 64 : 96,
        paddingBottom: mobile ? 64 : 96,
      }}
    >
      <Container pad={pad}>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: mobile ? "1fr" : "minmax(0,4fr) minmax(0,8fr)",
            gap: mobile ? 24 : 96,
            alignItems: "start",
          }}
        >
          <Eyebrow>Who</Eyebrow>
          <div
            style={{
              display: "flex",
              gap: mobile ? 24 : 40,
              flexDirection: mobile ? "column" : "row",
              alignItems: "flex-start",
            }}
          >
            <div style={{ display: "flex", flexDirection: "column", gap: 8, flexShrink: 0 }}>
              <PortraitPlaceholder size={120} caption="portrait" />
              <div
                style={{
                  fontFamily: "var(--ui)",
                  fontSize: 12,
                  color: "var(--text-2)",
                  lineHeight: 1.4,
                }}
              >
                Mira Avesh
                <br />
                <span style={{ color: "var(--text-3)" }}>Coach · designer</span>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 18,
                maxWidth: 540,
              }}
            >
              <p
                style={{
                  margin: 0,
                  fontFamily: "var(--ui)",
                  fontSize: mobile ? 17 : 18,
                  lineHeight: 1.6,
                  color: "var(--text)",
                }}
              >
                Speed AI is a small team in Brooklyn — a coach who&apos;s paced a hundred first
                marathons, and two designers who&apos;d rather build one careful thing than ten
                loud ones.
              </p>
              <p
                style={{
                  margin: 0,
                  fontFamily: "var(--ui)",
                  fontSize: mobile ? 17 : 18,
                  lineHeight: 1.6,
                  color: "var(--text)",
                }}
              >
                We made this because the people who&apos;ve never done it deserve the same care as
                the people who have.
              </p>
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
}
